import { useCallback, useMemo, useRef, useState } from "react";
import { File } from "@ludens-reklame/rubics-v3-sdk/file/types";
import { play } from "../../icons/index.js";
import { Wrapper } from "./styles.js";

interface Video {
  file?: File;
}

interface Subtitle {
  label?: string;
  lang?: string;
  default?: boolean;
  file?: File;
}

export interface Props {
  poster?: File;
  videos?: Video[];
  subtitles?: Subtitle[];
  text?: string;
}

export const Video: React.FunctionComponent<Props> = ({
  poster,
  videos = [],
  subtitles = [],
  text,
}) => {
  const [hasPlayed, setHasPlayed] = useState<boolean>(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const id = useMemo<string>(
    () => Math.random().toString(36).substring(2, 9),
    []
  );

  const handlePlay = useCallback(() => {
    if (videoRef.current) {
      const videoPlayer = videoRef.current;

      videoPlayer.play();
      setHasPlayed(true);
    }
  }, []);

  if (!poster && videos.length === 0) {
    return null;
  }

  return (
    <Wrapper className="video-wrapper" $hasPlayed={hasPlayed}>
      {!hasPlayed && poster && (
        <img className="video-poster" src={poster.url} alt="" />
      )}
      {!hasPlayed && (
        <button
          onClick={handlePlay}
          aria-label="Spill av video"
          aria-controls={id}
        >
          {play}
        </button>
      )}

      <video id={id} ref={videoRef} controls={hasPlayed} playsInline>
        {videos.map((v, k) => {
          if (!v.file) {
            return null;
          }

          return <source key={k} src={v.file.url} type={v.file.mimeType} />;
        })}
        {subtitles.map((s, k) => {
          if (!s.file) {
            return null;
          }

          return (
            <track
              key={k}
              label={s.label}
              kind="subtitles"
              srcLang={s.lang}
              src={s.file.url}
              default={s.default}
            />
          );
        })}
      </video>

      {!hasPlayed && text && (
        <div className="video-text">
          <p className="h3">{text}</p>
        </div>
      )}
    </Wrapper>
  );
};
